var lists_default = {
  "fontElementMap": "EaGTc",
  "orderedlist": "JfF1N",
  "bulletedlist": "dxIEi",
  "listItem": "_00bIy"
};
export {
  lists_default as default
};
//# sourceMappingURL=lists-scss.js.map
